import React from 'react'
import * as Yup from 'yup'
import { useNavigate, useParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { ArrowLeft, CheckCircle } from '@phosphor-icons/react'
import { Formik } from 'formik'

import TextField from '../FormLegacy/FormFieldsV2/TextField'
import { formValidation } from '../FormLegacy/validation'
import api from '../../api/api'

import AuthLayout from './AuthLayout'

const RequestPasswordInitialSetup = () => {
  const { t } = useTranslation(['auth', 'common'])
  const [isSubmitted, setIsSubmitted] = React.useState(false)
  const [error, setError] = React.useState('')
  const { email } = useParams()

  const validationSchema = Yup.object().shape({
    email: formValidation.email,
  })

  const navigate = useNavigate()

  const onSubmit = (values) => {
    setError('')
    setIsSubmitted(false)

    api
      .recoverPassword(values.email)
      .then(() => {
        setIsSubmitted(true)
      })
      .catch((code) => {
        if (code === 404) {
          setError(t('auth:login.userNotFound'))
          return
        }
        setError(t('auth:shared.somethingWentWrongLater'))
      })
  }

  return (
    <AuthLayout>
      <Formik
        initialValues={{
          email,
        }}
        validationSchema={validationSchema}
        onSubmit={onSubmit}
        enableReinitialize
      >
        {({ handleSubmit, values, handleChange, touched, errors }) =>
          isSubmitted ? (
            <div className="auth__password-reset-success">
              <CheckCircle size={32} />
              <h2>{t('auth:requestPasswordInitialSetup.sentTitle')}</h2>
              <p>{t('auth:requestPasswordReset.sentDescription')}</p>
              <button onClick={() => navigate('/login')} className="button button-primary">
                {t('auth:shared.backToLogin')}
              </button>
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="auth__form">
              <button
                type="button"
                className="auth__back-button"
                onClick={() => navigate('/login')}
              >
                <ArrowLeft />
                {t('common:actions.back')}
              </button>
              <h1>{t('auth:requestPasswordInitialSetup.title')}</h1>
              <p className="auth__step-description">{t('auth:requestPasswordReset.description')}</p>
              <TextField
                type="email"
                name="email"
                label={t('auth:shared.email')}
                placeholder={t('auth:shared.email')}
                value={values.email}
                onChange={handleChange}
                disabled
                isError={touched.email && !!errors.email}
              />
              {error && <p className="auth__form__description error">{error}</p>}
              <button type="submit" className="button button-primary">
                {t('auth:shared.sendVerificationEmail')}
              </button>
            </form>
          )
        }
      </Formik>
    </AuthLayout>
  )
}

export default RequestPasswordInitialSetup
